import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Runtime auto-recovery: transient failures (dropped connection, cold start,
  // rate blips) retry themselves with backoff instead of surfacing as a crash.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          const message = (error as { message?: string } | undefined)?.message ?? "";
          if (/permission denied|row-level security|not found|400|404/i.test(message)) return false;
          return failureCount < 3;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        staleTime: 30_000,
      },
      mutations: { retry: 1 },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
